module.exports = "/static/media/optus.606fe264.svg";